// @Serializable
import {Serializable} from './decorator-serializable';

// @referenceProp
import {referenceProp} from './decorator-reference-prop';

// @storeLocally
import {storeLocally} from './decorator-store-locally';

/********************************************* EXPORT *********************************************/
export {Serializable, referenceProp, storeLocally};

// Namespace for all Serialization decorators
export const SerializationDecorators = {Serializable, referenceProp, storeLocally};
